<div class="layout-col full">
  <mat-tab-group class="flex">
    <!-- product info -->
    <mat-tab label="{{ 'context.material' | translate }}">
      <elder-single-pane-wrapper>
        <elder-pane-content>
          <div class="flex layout-col">
            <elder-pane-subtitle>{{ 'context.general' | translate }}</elder-pane-subtitle>
            <div class="layout-row place-center-center gap-sm">
              <mat-form-field class="medium-xl-input">
                <mat-label>TypeId</mat-label>
                <input
                  [readonly]="true"
                  [value]="material().typeId"
                  matInput
                  name="typeId"
                  placeholder="TypeId"
                  type="text"
                />
              </mat-form-field>
              <mat-form-field class="medium-xl-input">
                <mat-label>Id</mat-label>
                <input
                  [readonly]="true"
                  [value]="material().id"
                  matInput
                  name="id"
                  placeholder="Id"
                  type="text"
                />
              </mat-form-field>
              <mat-form-field>
                <mat-label>GroupId</mat-label>
                <input
                  [readonly]="true"
                  [value]="material().groupId"
                  matInput
                  name="groupId"
                  placeholder="GroupId"
                  type="text"
                />
              </mat-form-field>
              <mat-form-field>
                <mat-label>{{ 'context.searchTerm' | translate }}</mat-label>
                <input
                  [readonly]="true"
                  [value]="material().searchTerm"
                  matInput
                  name="matchCode"
                  [placeholder]="'context.searchTerm' | translate"
                  type="text"
                />
              </mat-form-field>
            </div>
            <elder-localized-input
              name="descriptionI18n"
              [(ngModel)]="material().descriptionI18n"
              [readonly]="true"
            >
            </elder-localized-input>
            <elder-localized-input
              name="description2I18n"
              [(ngModel)]="material().description2I18n"
              [readonly]="true"
            >
            </elder-localized-input>
            <elder-localized-input
              name="description3I18n"
              [(ngModel)]="material().description3I18n"
              placeholder="Description 3"
              [readonly]="true"
            >
            </elder-localized-input>
            <mat-form-field>
              <mat-label>{{ 'context.materialGroup' | translate }}</mat-label>
              <input
                [readonly]="true"
                [value]="material().groupId"
                matInput
                name="groupId"
                placeholder="{{ 'context.materialGroup' | translate }}"
                type="text"
              />
            </mat-form-field>
            <div class="layout-col gap-lg">
              <div>
                <elder-pane-subtitle>Family Ids</elder-pane-subtitle>
                @if (material().familyIds.length === 0) {
                  <span>-</span>
                }
                <div class="layout-row gap-sm">
                  @for (familyId of material().familyIds; track familyId) {
                    <mat-chip-set placeholder="familyIds">
                      <mat-chip highlighted>{{ familyId }}</mat-chip>
                    </mat-chip-set>
                  }
                </div>
              </div>
              <div>
                <elder-pane-subtitle>{{ 'context.labels' | translate }}</elder-pane-subtitle>
                @if (material().labels.length === 0) {
                  <span>-</span>
                }
                <div class="layout-row gap-sm">
                  @for (label of material().labels; track label) {
                    <mat-chip-listbox placeholder="Labels">
                      <mat-chip-option>{{ label }}</mat-chip-option>
                    </mat-chip-listbox>
                  }
                </div>
              </div>
              <mat-checkbox [disabled]="true" [checked]="material().archived" name="archived">
                {{ 'context.archived' | translate }}
              </mat-checkbox>
            </div>
          </div>
        </elder-pane-content>
      </elder-single-pane-wrapper>
    </mat-tab>
  </mat-tab-group>
</div>
